import { t } from "@impero-com/common/utils/i18n";
import { Tag } from "@impero-com/ui";
import { notification } from "antd";

import { copyDataToClipboard } from "utils/clipboard";

interface CopyableTagProps {
    value: string;
}

export function CopyableTag({ value }: CopyableTagProps) {
    const copyIdToClipboard = () => {
        copyDataToClipboard(value);
        notification.success({
            message: t("ShareableLinkPopup_CopiedToClipboard"),
        });
    };

    return <Tag onClick={copyIdToClipboard}>{value}</Tag>;
}
